import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import "./ProfitLoss.css";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Legend
} from "recharts";

class ProfitLoss extends Component {
    render() {
        const {
            today,
            yesterday,
            week,
            month
        } = this.props;
        return (
            <div className="content profit-loss-page">
                <Grid fluid>
                    {/* Header */}
                    <Row>
                        <Col md={12}>
                            <div className="profit-loss-header">
                                <div>
                                    <h3>Profit & Loss</h3>
                                    <p>Gross Sales and Expenses summary</p>
                                </div>
                                <Button
                                    bsStyle="primary"
                                    className="export-btn"
                                >
                                    <i className="fa fa-download" /> Export Excel
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    {/* Summary Cards */}
                    <Row>
                        <Col md={3} className="card">
                            <div className="pl-card">
                                <h4>Today</h4>
                                <div className="pl-row">
                                    <span>Gross Sales: </span>
                                    <strong>₹{Math.round(today.sales)}</strong>
                                </div>
                                <div className="pl-row">
                                    <span>Expenses: </span>
                                    <strong>₹{Math.round(today.expenses)}</strong>
                                </div>
                                <hr />
                                <div className="pl-row profit">
                                    <span>Profit / Loss: </span>
                                    <strong>₹{Math.round(today.profit)}</strong>
                                </div>
                            </div>
                        </Col>

                        <Col md={3} className="card">
                            <div className="pl-card">
                                <h4>Yesterday</h4>
                                <div className="pl-row">
                                    <span>Gross Sales: </span>
                                    <strong>₹{Math.round(yesterday.sales)}</strong>
                                </div>
                                <div className="pl-row">
                                    <span>Expenses: </span>
                                    <strong>₹{Math.round(yesterday.expenses)}</strong>
                                </div>
                                <hr />
                                <div className="pl-row profit">
                                    <span>Profit / Loss: </span>
                                    <strong>₹{Math.round(yesterday.profit)}</strong>
                                </div>
                            </div>
                        </Col>

                        <Col md={3} className="card">
                            <div className="pl-card">
                                <h4>Last Week</h4>
                                <div className="pl-row">
                                    <span>Gross Sales: </span>
                                    <strong>₹{Math.round(week.sales)}</strong>
                                </div>
                                <div className="pl-row">
                                    <span>Expenses: </span>
                                    <strong>₹{Math.round(week.expenses)}</strong>
                                </div>
                                <hr />
                                <div className="pl-row profit">
                                    <span>Profit / Loss: </span>
                                    <strong>₹{Math.round(week.profit)}</strong>
                                </div>
                            </div>
                        </Col>

                        <Col md={3} className="card">
                            <div className="pl-card">
                                <h4>Last Month</h4>
                                <div className="pl-row">
                                    <span>Gross Sales: </span>
                                    <strong>₹{Math.round(month.sales)}</strong>
                                </div>
                                <div className="pl-row">
                                    <span>Expenses: </span>
                                    <strong>₹{Math.round(month.expenses)}</strong>
                                </div>
                                <hr />
                                <div className="pl-row profit">
                                    <span>Profit / Loss: </span>
                                    <strong>₹{Math.round(month.profit)}</strong>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {/* Custom Date */}
                    <Row className="custom-date-section">
                        <Col md={12} className="card">
                            <div className="pl-custom-card">
                                <h4>Custom Date</h4>
                                <Row>
                                    <Col md={4}>
                                        <label>From Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={this.props.fromDate}
                                            onChange={this.props.onFromDateChange}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <label>To Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={this.props.toDate}
                                            onChange={this.props.onToDateChange}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <label>&nbsp;</label>
                                        <button
                                            className="btn btn-primary form-control"
                                            onClick={this.props.onApplyCustomDate}
                                        >
                                            Apply
                                        </button>
                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col md={4}>
                                        <div className="custom-result">
                                            <span>Gross Sales</span>
                                            <strong>
                                                ₹{Math.round(this.props.custom.sales)}
                                            </strong>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="custom-result">
                                            <span>Expenses</span>
                                            <strong>
                                                ₹{Math.round(this.props.custom.expenses)}
                                            </strong>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="custom-result">
                                            <span>Profit / Loss</span>
                                            <strong>
                                                ₹{Math.round(this.props.custom.profit)}
                                            </strong>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            {/* =======================================
                                    Profit & Loss
                                    Month-wise / Day-wise
                                    Gross Sales vs Expenses vs Profit/Loss
                            ======================================= */}
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <div className="card">

                                        {/* ================================
                  HEADER
            ================================= */}
                                        <div className="card-header">
                                            <div className="d-flex justify-content-between align-items-center">

                                                <h5 className="mb-0">
                                                    Profit & Loss
                                                </h5>

                                                <div className="d-flex align-items-center">

                                                    {/* YEAR */}
                                                    <label className="mb-0 mr-2">
                                                        Year:
                                                    </label>

                                                    <select
                                                        className="form-control mr-3"
                                                        value={this.props.profitLossYear}
                                                        onChange={this.props.onProfitLossYearChange}
                                                        style={{
                                                            width: "120px"
                                                        }}
                                                    >
                                                        {(this.props.yearList || []).map(
                                                            year => (
                                                                <option
                                                                    key={year}
                                                                    value={year}
                                                                >
                                                                    {year}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>

                                                    {/* MONTH */}
                                                    <label className="mb-0 mr-2">
                                                        Month:
                                                    </label>

                                                    <select
                                                        className="form-control"
                                                        value={this.props.profitLossMonth}
                                                        onChange={this.props.onProfitLossMonthChange}
                                                        style={{
                                                            width: "140px"
                                                        }}
                                                    >
                                                        <option value="all">
                                                            All Months
                                                        </option>

                                                        <option value="0">
                                                            January
                                                        </option>

                                                        <option value="1">
                                                            February
                                                        </option>

                                                        <option value="2">
                                                            March
                                                        </option>

                                                        <option value="3">
                                                            April
                                                        </option>

                                                        <option value="4">
                                                            May
                                                        </option>

                                                        <option value="5">
                                                            June
                                                        </option>

                                                        <option value="6">
                                                            July
                                                        </option>

                                                        <option value="7">
                                                            August
                                                        </option>

                                                        <option value="8">
                                                            September
                                                        </option>

                                                        <option value="9">
                                                            October
                                                        </option>

                                                        <option value="10">
                                                            November
                                                        </option>

                                                        <option value="11">
                                                            December
                                                        </option>
                                                    </select>

                                                </div>
                                            </div>
                                        </div>

                                        {/* ================================
                  CHART
            ================================= */}
                                        <div className="card-body">

                                            <div
                                                style={{
                                                    width: "100%",
                                                    overflowX: "auto",
                                                    overflowY: "hidden"
                                                }}
                                            >

                                                <div
                                                    style={{
                                                        width: Math.max(
                                                            800,
                                                            (this.props.profitLossChartData || []).length * 150
                                                        ),
                                                        height: 400
                                                    }}
                                                >

                                                    <ResponsiveContainer
                                                        width="100%"
                                                        height="100%"
                                                    >

                                                        <BarChart
                                                            data={
                                                                this.props.profitLossChartData || []
                                                            }
                                                            margin={{
                                                                top: 20,
                                                                right: 30,
                                                                left: 60,
                                                                bottom: 60
                                                            }}
                                                        >

                                                            <CartesianGrid
                                                                strokeDasharray="3 3"
                                                            />

                                                            <XAxis
                                                                dataKey="label"
                                                                interval={0}
                                                                angle={
                                                                    this.props.profitLossMonth === "all"
                                                                        ? 0
                                                                        : -45
                                                                }
                                                                textAnchor={
                                                                    this.props.profitLossMonth === "all"
                                                                        ? "middle"
                                                                        : "end"
                                                                }
                                                                height={
                                                                    this.props.profitLossMonth === "all"
                                                                        ? 50
                                                                        : 90
                                                                }
                                                            />

                                                            <YAxis />

                                                            <Tooltip
                                                                formatter={(value, name) => [
                                                                    `₹ ${Number(value).toLocaleString("en-IN")}`,
                                                                    name
                                                                ]}
                                                            />

                                                            <Legend />

                                                            {/* Gross SALES */}
                                                            <Bar
                                                                dataKey="grossSales"
                                                                name="Gross Sales"
                                                                fill="#17a2b8"
                                                            />

                                                            {/* EXPENSES */}
                                                            <Bar
                                                                dataKey="expenses"
                                                                name="Expenses"
                                                                fill="#dc3545"
                                                            />

                                                            {/* PROFIT / LOSS */}
                                                            <Bar
                                                                dataKey="profitLoss"
                                                                name="Profit / Loss"
                                                                fill="#28a745"
                                                            />

                                                        </BarChart>

                                                    </ResponsiveContainer>

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
export default ProfitLoss;